import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PAGINAS_DISPONIBLES } from '../../../core/config/permisos-paginas2';

@Injectable({ providedIn: 'root' })
export class PermisosService {
  private baseUrl = `${environment.apiUrl}/config/permisos`;

  constructor(private http: HttpClient) {}

  getAdminUsers(params?: any) {
    return this.http.get<{ usuarios: { id: number; nombreCompleto: string }[]; total: number }>(`${this.baseUrl}/directory/users`, { params });
  }

  getUsuarios() {
    return this.http.get<any[]>(`${environment.apiUrl}/usuarios`);
  }

  getDirectorySelection(params: any) {
    return this.http.get<any[]>(this.baseUrl + '/directory/users', { params });
  }
  actualizarPermisos(cambios: { usuarioId: number; rutas: string[] }[], operacion?: 'asignar' | 'retirar') {
    const page_catalog_routes = [...new Set(PAGINAS_DISPONIBLES.flatMap(group => group.paginas.map(page => page.ruta)))];
    return this.http.post(`${this.baseUrl}/actualizar`, { cambios, page_catalog_routes, ...(operacion ? { operacion } : {}) });
  }

  obtenerPermisosPorUsuario(usuarioId: number) {
    return this.http.get<string[]>(`${this.baseUrl}/${usuarioId}`);
  }
  descargarExcelPermisos() {
    const url = `${this.baseUrl}/exportar/excel`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
